import React, { useContext, useEffect} from 'react';
import { useWebsite } from '../../../../hooks/useWebsite'
import cl from './List.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import Add from '../Add/Add'; 
import Delete from '../Delete/Delete';
import Edit from '../Edit/Edit';
import tbl from '../../../../assets/Style/Table.module.css'
import { useTranslation } from 'react-i18next';

const WebsiteList = () => {
  const {t} = useTranslation();
  const { websiteService } = useWebsite(50);
  const {appState, app} = useContext(AppContext);

  useEffect( ()=> {
     websiteService.fetchList()
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    websiteService.setFilter({
      ...websiteService.filter,
      [name]: value
    });
  };
 

  return <div>

    <div className={ cl.headMain }> 
        <h1>{t('Sites')}</h1>   
        <Add websiteService={websiteService} /> 
    </div>


    <div className={tbl.table + ' ' + cl.table}>

      <table>
          <thead>
              <tr>
              <th className={cl.id}>#</th>
              <th className={ cl.pad0 }>
                  <input name="name"  placeholder={t('Name')} value={websiteService.filter.name} onChange={handleInputChange} /> 
              </th>
              <th>{t('Level')} 1</th>
              <th>{t('Level')} 2</th>
              <th>{t('Level')} 3</th>
              <th>{t('Level')} 4</th>
              <th>{t('Level')} 5</th>
              <th>{t('CompanyProfit')}</th>
              <th> </th> 
              </tr>
          </thead>
          <tbody>
              {websiteService.items.map((item) =>
                  <tr key={item.id} >
                  < td className={cl.id} >{item.id} </td>
                  <td>{item.name}</td> 
                  <td>{item.level1} $</td>
                  <td>{item.level2} $</td>
                  <td>{item.level3} $</td>
                  <td>{item.level4} $</td>
                  <td>{item.level5} $</td>
                  <td>{item.company_win} $</td> 
                  <td className={ cl.btntbl }>
                      <div className={ cl.btns }>
                        <Edit websiteService={websiteService} defaultWebsite={item}/>
                        <Delete websiteService={websiteService} defaultWebsite={item}/> 
                      </div>
                  </td>
                  </tr>  
              )}
          </tbody>
      </table>

    </div>

  
   {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={websiteService.total} 
                perPage={websiteService.filter.limit} 
                current={websiteService.filter.page} 
                paginate={(page) => {
                    websiteService.setFilter({
                    ...websiteService.filter,
                    page: page,
                  });
                }}
                setLimit={(limit) => {
                    websiteService.setFilter({
                    ...websiteService.filter,
                    limit: limit,
                  });
                }}
                />
  </div>;
}

export default WebsiteList;